import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  actionPopover: {
    zIndex: "99 !important",
  },
  menu: {
    "& li": {
      fontSize: 14,
      padding: "5px 15px",
    },
  },
  actionPopoverList: {
    padding: 0,
    margin: "8px 0",
    "& li": {
      listStyle: "none",
      "& button, a": {
        textAlign: "left",
        display: "block",
        width: "100%",
        lineHeight: "18px",
        borderRadius: 0,
        fontSize: 13,
        padding: "6px 15px",
      },
    },
    "&.target-list-menu": {
      "& button, a": {
        padding: "7px 28px",
      },
    },
  },
  divider: {
    borderTop: "solid 0.5px #707070",
    width: "80%",
    height: 1,
    display: "block",
    margin: "5px auto",
  },
  detailsLink: {
    textDecoration: "none",
    color: "inherit",
    display: "block",
    padding: "6px 15px",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.04)",
    },
  },
  disableKebab: {
    color: "#ccc !important",
  },
  kebabMenu: {
    position: "relative",
    marginLeft: 5,
  },
  kebabNotif: {
    position: "absolute",
    "&:after": {
      position: "absolute",
      top: -5,
      right: -7,
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: "#EF7713",
      content: '""',
    },
  },
  kebabMenuCount: {
    width: 16,
    height: 16,
    minWidth: 16,
    fontSize: 11,
    borderRadius: "50%",
    background: "#EF7713",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 6,
    position: "absolute",
    left: 8,
    top: 7,
  },
}));

export default useStyles;
